
import React from 'react';
import { FaFilePdf, FaFileWord } from 'react-icons/fa'; 
import './SopDownloadSection.css'; 

const SopDownloadSection = () => {
  return (
    <section className="_sDSect_r1A_"> 
      <div className="_sDCont_s2B_"> 
        <h2 className="_dSectTitle_t3C_ _hTitle_s5E_ features-title _hTitle_z5E_" style={{paddingBottom:"1.3rem",marginBottom:'1.6rem'}}> 
          Download or Read the Full SOP
        </h2>
        <div className="_dBtnWrapper_u4C_" style={{paddingTop:"0", marginBottom:'1.6rem'}}> 
          <a
            href="/files/VanijyamSOP.pdf" 
            target="_blank"
            rel="noopener noreferrer"
            className="_dBtn_v5C_ pdf-button" 
          >
            <FaFilePdf className="_bIcon_w6D_" /> Download SOP (PDF)
          </a>
          <a
            href="/files/VanijyamSOP.docx" 
            target="_blank"
            rel="noopener noreferrer"
            className="_dBtn_v5C_ word-button" 
          >
            <FaFileWord className="_bIcon_w6D_" /> Download SOP (Word)
          </a>
        </div>
        <p className="_dNote_x7D_" style={{marginTop:"0",paddingTop:"0"}}> 
          (If you need a signed copy or version history, contact
          <a href="mailto:support@vanidya.com" className="_eLink_y8D_">
            support@vanidya.com
          </a>
          )
        </p>
      </div>
    </section>
  );
};

export default SopDownloadSection;
